import * as React from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import styles from "./styles.module.scss";
import { ReactComponent as Cross } from "../../../assets/industries/model/x.svg";

// const style = {
//   position: "absolute",
//   top: "50%",
//   left: "50%",
//   transform: "translate(-50%, -50%)",
//   width: 400,
//   bgcolor: "background.paper",
//   border: "2px solid #000",
//   boxShadow: 24,
//   p: 4,
// };

export default function BasicModal({
  open,
  setOpen,
  children,
  setTotalPrice,
  price,
  cart,
  setCart,
  feature,
}) {
  const handleClose = (_, reason) => {
    if (reason === "backdropClick") {
      return;
    }
    setOpen(false);
    if (price) {
      setTotalPrice("");
    }
    if (feature === true) {
      setCart({});
      // console.log(cart);
    }
  };

  return (
    <>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className={`${styles.industryModel}`}
      >
        <Box className={`${styles.boxModel} xym1`}>
          <Box className={styles.cross} onClick={handleClose}>
            <Cross />
          </Box>
          <Box className={styles.body}>{children}</Box>
        </Box>
      </Modal>
    </>
  );
}
